var React = require('react');

function Curation (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0H16V16H0z","key":0}),React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M10.966 6.14C10.346 5.155 9.25 4.5 8 4.5 6.067 4.5 4.5 6.067 4.5 8s1.567 3.5 3.5 3.5c1.306 0 2.399-.44 3-1.5","key":0}),React.createElement("rect",{"width":"15","height":"15","x":".5","y":".5","rx":"1","key":1})])]));
}

Curation.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Curation;

Curation.default = Curation;
